import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const ProductDetailSpecification = ({ className , items  })=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.detail.specifications.title');
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('product-detail-specification', className),
        "aria-label": title,
        "data-t": "product-detail-specification"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: "product-detail-specification__title"
    }, title), /*#__PURE__*/ React.createElement("dl", {
        className: "product-detail-specification__list"
    }, items));
};

export { ProductDetailSpecification };
//# sourceMappingURL=ProductDetailSpecification.js.map
